import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Nav, Row, Tab, Spinner } from "react-bootstrap";
import "./NewHome.css";
import NewHeader from "../../directives/NewHeader";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { SlLocationPin } from "react-icons/sl";
import { Link } from "react-router-dom";
import Footer from "../../directives/footer";
import { IoArrowBack } from "react-icons/io5";
import { motion, AnimatePresence } from "framer-motion";
import DownloadSection from "./DownloadSection";
import NewCounter from "./NewCounter";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";

const headers = [
  "Move To Earn",
  "Steps Into Wealth",
  "Fitness Pays Off",
  "Every Step Counts",
];
const NewHome = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % headers.length);
    }, 2000); // change text every 2 seconds

    return () => clearInterval(interval);
  }, []);


  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);
  console.log(swiperRef.current)

  useEffect(() => {
    if (swiperRef.current && swiperRef.current.params) {
      swiperRef.current.params.navigation.prevEl = prevRef.current;
      swiperRef.current.params.navigation.nextEl = nextRef.current;

      // Re-init navigation
      swiperRef.current.navigation.destroy();
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, []);
  return (
    <>
      <div className="position-fixed w-100" style={{ zIndex: 999 }}>
        <NewHeader />
      </div>

      <div className="color-container">
        <div className="new-home-section3">
          <div className="c1"></div>
          <div className="c2"></div>
          <div className="c3"></div>
          <div className="c4"></div>

          <Container className="">
            <div className="newhome-section1">
              <div className="" style={{ height: 120 }}></div>

              <div
                className="position-absolute"
                style={{ zIndex: "-1", bottom: 0, opacity: 0.7 }}
              >
                <img
                  src="assets/images/newdesign/hero02.png"
                  style={{ height: 500 }}
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="d-flex flex-column gap-2 align-items-center">
                {/* <h1 className='newhome-header'>MOVE TO EARN</h1> */}
                <AnimatePresence mode="wait">
                  <motion.h1
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -20 }}
                    transition={{ duration: 1 }}
                    className="newhome-header w-100 mb-3"
                    style={{ width: "100%", textAlign: "center" }}
                  >
                    {headers[index]}
                  </motion.h1>
                </AnimatePresence>

                <p className="newhome-para">
                  Every Step Counts, Every Step Pays.
                </p>
                <div className="position-relative">
                  <h3 className="new-hone-custom-text">STEPMINT</h3>
                  <img
                    src="assets/images/newdesign/hero01.png"
                    style={{
                      maxHeight: 400,
                      objectFit: "contain",
                      width: "100%",
                    }}
                    className="img-fluid h-100 main-hero-img01"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </Container>
        </div>

        {/* SECTION 2 */}
        <div className="new-home-section2 py-4 ">
          <Container className="d-flex h-100 align-items-center w-100">
            <Row className="w-100 cust-row ">
              <Col className="custom-col d-flex align-items-center flex-column justify-content-center">
                <p className="new-home-s2-header">
                  {" "}
                  <NewCounter targetNumber={152600} duration={500} />
                </p>
                <p className="new-home-s2-para">App Downloads</p>
              </Col>
              <Col className="custom-col d-flex align-items-center flex-column justify-content-center">
                <div
                  className="d-flex gap-2 align-items-center justify-content-center"
                  style={{ marginBottom: 16 }}
                >
                  <p className="new-home-s2-header mb-0">4.8/5.0</p>
                  <div>
                    <img src="assets/images/newdesign/star.svg" alt="" />
                    <img src="assets/images/newdesign/star.svg" alt="" />
                    <img src="assets/images/newdesign/star.svg" alt="" />
                    <img src="assets/images/newdesign/star.svg" alt="" />
                    <img src="assets/images/newdesign/star.svg" alt="" />
                  </div>
                </div>
                <p className="new-home-s2-para">Overall Rating</p>
              </Col>
              <Col className="custom-col d-flex align-items-center flex-column justify-content-center">
                <p className="new-home-s2-header">
                  {" "}
                  <NewCounter targetNumber={73586} duration={500} />
                </p>
                <p className="new-home-s2-para">Subscribers</p>
              </Col>
              <Col className="custom-col d-flex align-items-center flex-column justify-content-center">
                <div className="d-flex align-items-center">
                  <img src="assets/images/newdesign/qr.svg" alt="" />
                  <p className="new-home-s2-para">
                    Scan QR code to join community
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {/* SECTION 3 */}
        <div className="new-home-section3 py-5 my-5">
          <div className="c31"></div>
          <div className="c32"></div>
          <div className="c33"></div>
          <div className="c34"></div>
          <div className="new-home-s3-right-div"></div>
          <Container>
            <Row>
              <Col lg={7}>
                <div>
                  <h3 className="new-home-s3-heading1">
                    Step Into the Future of
                    <span className="new-home-s3-heading2"> Fitness</span>{" "}
                  </h3>
                  {/* <h3 className='new-home-s3-heading1'>What is <span className='new-home-s3-heading2'>Stepmint?</span> </h3> */}
                  <p>
                    StepMint is a next-gen fitness platform that transforms your
                    steps into real crypto rewards. Powered by Web3, our
                    move-to-earn ecosystem lets you earn while staying active.
                    <br />
                    It’s not just about walking. It’s about walking into wealth.
                  </p>
                  <div className="new-home-s3-div p-3 mb-4">
                    <p className="mb-0 new-home-s3-para2 text-white">
                      What is{" "}
                      <span style={{ color: "#00EEF5" }}>StepMint?</span>{" "}
                    </p>
                  </div>
                  <ul className="new-home-s3-list">
                    <li>
                      <img src="assets\images\newdesign\icon.svg" alt="" />
                      StepMint is a subscription-based fitness platform designed
                      to help you lead a healthier and more active lifestyle.
                    </li>
                    <li>
                      <img src="assets\images\newdesign\icon.svg" alt="" />{" "}
                      Through our easy-to-use app, you can track your daily
                      steps, participate in exciting community challenges, and
                      earn Step Rewards in the form of Mr Mint tokens/coins
                    </li>
                    <li>
                      <img src="assets\images\newdesign\icon.svg" alt="" />
                      The subscription is valid for 365 days.
                    </li>
                    <li>
                      <img src="assets\images\newdesign\icon.svg" alt="" />
                      By completing your 10000 steps goal within a 6-hour daily
                      window, you can earn Step Rewards .
                    </li>
                  </ul>
                  {/* <ul className='new-home-s3-list'>
            <li><img src="assets\images\newdesign\icon.svg" alt="" />Health Oasis: No sick days ahead!</li>
            <li><img src="assets\images\newdesign\icon.svg" alt="" />Your ticket to a happy mind.</li>
            <li><img src="assets\images\newdesign\icon.svg" alt="" />Revitalize your day with a power surge!</li>
            <li><img src="assets\images\newdesign\icon.svg" alt="" />Strong immunity and better sleep.</li>
            <li><img src="assets\images\newdesign\icon.svg" alt="" />Your passport to an injury-free, vibrant life.</li>
            <li><img src="assets\images\newdesign\icon.svg" alt="" />31% lower mortality risk.</li>
            <li><img src="assets\images\newdesign\icon.svg" alt="" />Stressed? Let every step be your stress vanisher!</li>
            <li><img src="assets\images\newdesign\icon.svg" alt="" />Shedding weight, one step at a time!</li>
        </ul> */}
                </div>
              </Col>
              <Col lg={5}>
                <div className="new-home-s3-right">
                  <img
                    src="assets/images/newdesign/phone2.png"
                    className="img-fluid"
                    alt=""
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {/* SECTION 4 */}
        <div className="new-home-section3 py-sm-5 py-1">
          <Container>
            <div className="new-home-section4 mt-5 mb-5">
              <h3 className="new-home-section4-backheader">WHY STEPMINT</h3>
              <p className="new-home-section4-header">WHY CHOOSE STEPMINT</p>
            </div>
            <h3 className="text-center mb-3 why-stepmint">
              More Than Steps. <span className="why-stepmint-span">It’s a Movement.</span> 
            </h3>
            <div className="w-100 d-flex align-items-center justify-content-center">
              <p className="text-center w-75 mb-3" style={{ fontSize: 14 }}>
                At StepMint, our mission isn’t just about hitting a number —
                it’s about building a community where everyone belongs, grows,
                and thrives.
                <br />
                We’re creating a diverse, inclusive, and health-first ecosystem
                that welcomes people of all ages, fitness levels, and
                backgrounds. Whether you’re a beginner or a marathoner, StepMint
                empowers you to move forward — at your own pace, with real
                purpose.
              </p>
            </div>
            <div>
              <div className="c1"></div>
              <div className="c2"></div>
              <div className="c3"></div>
              <Container>
                <div className="new-home-section4-2 p-sm-4 py-4 px-sm-5 px-2 ">
                  <div className="nh-design1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="434"
                      height="361"
                      viewBox="0 0 434 361"
                      fill="none"
                      opacity={0.2}
                    >
                      <path
                        className="animated-path "
                        d="M-87.0122 351.038C-99.5889 293.109 -94.6869 231.493 -73.1146 176.254C-59.063 140.282 -18.9123 60.7988 30.1988 102.704C53.1182 122.259 78.4971 210.055 89.9612 228.844C111.36 263.897 154.596 248.391 179.357 221.392C212.86 184.871 210.343 139.117 209.384 92.93C208.948 71.9516 205.719 50.1137 193.688 32.9008C181.661 15.7023 158.844 4.62798 139.058 11.6488C113.749 20.6066 105.566 56.3322 119.708 79.1238C133.849 101.915 163.372 111.56 190.064 108.767C212.423 106.422 234.193 96.741 256.543 99.2191C299.233 103.954 323.248 146.559 350.095 174.781C370.018 195.718 395.967 214.227 424.871 213.325"
                        stroke="url(#paint0_linear_173_1300)"
                        stroke-width="18"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_173_1300"
                          x1="-131.609"
                          y1="-137.094"
                          x2="458.607"
                          y2="-65.7433"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#41D2FF" />
                          <stop offset="0.474" stop-color="#7E42FF" />
                          <stop offset="0.9619" stop-color="#DD3FFF" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  <div className="nh-design2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="404"
                      height="459"
                      viewBox="0 0 404 459"
                      fill="none"
                      opacity={0.2}
                    >
                      <path
                        className="animated-path"
                        d="M9.80607 102.714C50.7658 59.863 104.565 29.4309 162.414 16.3816C200.087 7.88674 288.425 -3.34054 281.196 60.8128C277.823 90.7517 219.282 160.931 210.131 180.949C193.066 218.304 230.119 245.449 266.352 250.851C315.37 258.167 351.873 230.467 389.607 203.816C406.746 191.71 423.033 176.809 430.561 157.204C438.079 137.61 434.482 112.505 417.587 100.04C395.996 84.0835 361.812 97.3031 350.844 121.78C339.875 146.257 348.411 176.119 365.669 196.673C380.129 213.888 400.338 226.506 410.797 246.414C430.772 284.437 408.913 328.188 400.558 366.233C394.363 394.462 393.553 426.326 410.481 449.771"
                        stroke="url(#paint0_linear_173_1301)"
                        stroke-width="18"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_173_1301"
                          x1="389.311"
                          y1="-207.508"
                          x2="660.607"
                          y2="321.495"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#41D2FF" />
                          <stop offset="0.474" stop-color="#7E42FF" />
                          <stop offset="0.9619" stop-color="#DD3FFF" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                  <div className="nh-design3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="206"
                      height="457"
                      viewBox="0 0 206 457"
                      fill="none"
                      opacity={0.2}
                    >
                      <path
                        className="animated-path "
                        d="M-228.009 103.328C-187.319 60.2198 -133.711 29.4504 -75.9459 16.038C-38.3267 7.30668 49.939 -4.47523 43.1128 59.7223C39.928 89.6818 -18.1707 160.228 -27.1961 180.303C-44.0263 217.763 -6.80384 244.675 29.4628 249.85C78.5255 256.858 114.854 228.93 152.42 202.042C169.482 189.829 185.676 174.826 193.08 155.174C200.475 135.533 196.72 110.45 179.748 98.092C158.057 82.2715 123.957 95.7055 113.142 120.251C102.328 144.796 111.051 174.604 128.437 195.049C143.006 212.173 163.293 224.664 173.877 244.505C194.09 282.403 172.507 326.29 164.391 364.386C158.373 392.655 157.763 424.523 174.838 447.861"
                        stroke="url(#paint0_linear_173_1299)"
                        stroke-width="18"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_173_1299"
                          x1="149.541"
                          y1="-209.272"
                          x2="424.154"
                          y2="318.017"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#41D2FF" />
                          <stop offset="0.474" stop-color="#7E42FF" />
                          <stop offset="0.9619" stop-color="#DD3FFF" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>

                  <Container className="d-flex flex-column pt-4 gap-3">
                    <Row className="px-md-5 px-1 gy-3 ">
                      <Col lg={5}>
                        <div>
                          <img
                            src="assets\images\newdesign\newsection401.png"
                            className="img-fluid w-100"
                            style={{
                              maxHeight: 250,
                              objectFit: "contain",
                              borderRadius: 20,
                            }}
                            alt=""
                          />
                        </div>
                      </Col>
                      <Col
                        lg={7}
                        className="d-flex flex-column justify-content-center"
                      >
                        <div>
                          <p className="new-home-section4-cardheader">
                            👟 Daily 10K Challenge
                          </p>
                          <p className="new-home-section4-cardpara">
                            By completing 10,000 steps within a 6-hour window,
                            you're not just earning — you're contributing to a
                            larger movement built on well-being, accountability,
                            and consistency.
                          </p>
                          {/* <div className='new-home-section4-cardbutton'>
            <p>See More ----</p>
        </div> */}
                        </div>
                      </Col>
                    </Row>

                    <Row className="px-md-5 px-1 gy-3 flex-row-reverse">
                      <Col lg={5}>
                        <div>
                          <img
                            src="assets\images\newdesign\newsection403.png"
                            className="img-fluid w-100"
                            style={{
                              maxHeight: 250,
                              objectFit: "contain",
                              borderRadius: 20,
                            }}
                            alt=""
                          />
                        </div>
                      </Col>
                      <Col
                        lg={7}
                        className="d-flex flex-column justify-content-center"
                      >
                        <div>
                          <p className="new-home-section4-cardheader">
                            🤝 Progress Over Perfection
                          </p>
                          <p className="new-home-section4-cardpara">
                            {" "}
                            Our platform celebrates small wins, shared goals,
                            and real community spirit. Through daily rewards,
                            and positive reinforcement, StepMint connects you
                            with others who are walking the same journey.
                          </p>
                          {/* <div className='new-home-section4-cardbutton'>
            <p>See More ----</p>
        </div> */}
                        </div>
                      </Col>
                    </Row>

                    <Row className="px-md-5 px-1 gy-3 ">
                      <Col lg={5}>
                        <div>
                          <img
                            src="assets\images\newdesign\newsection402.png"
                            className="img-fluid w-100"
                            style={{
                              maxHeight: 250,
                              objectFit: "contain",
                              borderRadius: 20,
                            }}
                            alt=""
                          />
                        </div>
                      </Col>
                      <Col
                        lg={7}
                        className="d-flex flex-column justify-content-center"
                      >
                        <div>
                          <p className="new-home-section4-cardheader">
                            🌍 Together, We Move
                          </p>
                          <p className="new-home-section4-cardpara">
                            {" "}
                            StepMint is more than an app — it’s a global network
                            of encouragement, achievement, and meaningful
                            change.
                          </p>
                          {/* <div className='new-home-section4-cardbutton'>
            <p>See More ----</p>
        </div> */}
                        </div>
                      </Col>
                    </Row>
                  </Container>
                  <br />
                  <br />
                  <div className="w-100 d-flex align-items-center justify-content-center">
                    <p
                      className="text-center w-75 mb-3"
                      style={{ fontSize: 16 }}
                    >
                      At StepMint, our Every step matters. Every person counts.{" "}
                      <br />
                      <span className="custom-new-text2">
                        {" "}
                        StepMint — where walking turns into wellness, and
                        movement becomes momentum.
                      </span>
                    </p>
                  </div>
                </div>
              </Container>
            </div>
          </Container>
        </div>
        {/* SECTION 5 */}
        {/* <div className="new-home-section3 py-4">

     <div className='new-home-section4  '>
                <h3 className='new-home-section4-backheader'>EVENTS</h3>
                <p className='new-home-section4-header'>OUR EVENTS</p>
            </div>
     </div> */}
        {/* <Container>
    <div className='d-flex justify-content-center'>
        <p className='text-center new-event '>A journey that’s going to make you Wealthier, Step by Step! Stepmint is the first step for connecting your Health with Wealth. Stepmint integrates fitness and Wealth with real crypto rewards through Web 3.0 technology.</p>
     </div>
     <div className='d-flex gap-3 flex-wrap w-100 justify-content-center'>
        <div className='new-home-section-5-btn '>
           
        <p className='new-home-section-5-btninner mb-0'>Events</p>
        </div>
        <div className='new-home-section-5-btn '>
       <p className='new-home-section-5-btninner mb-0'>Upcoming Events</p>
        </div>
        <div className='new-home-section-5-btn '>
       <p className='new-home-section-5-btninner mb-0'>Gallery</p>
        </div>
     </div>

     <div className='py-5'>
<div className='w-100 d-flex justify-content-between'>
<h3 style={{fontWeight:600}}>Popular Events</h3>
<Link className='new-home-section-5-btninner' style={{fontWeight:600}}>See More</Link>
</div>
<br />
     <div className="swiper-container">
          <button className="swiper-button-prev"></button>
          <button className="swiper-button-next"></button>
          <Swiper
            slidesPerView={3}
            spaceBetween={30}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              320: { slidesPerView: 1 },  // Small screens
              640: { slidesPerView: 1 },  // Tablets
              1024: { slidesPerView: 3 }, // Desktops
              1440: { slidesPerView: 3 }, // Larger screens
            }}
            modules={[Navigation, Pagination]}
            className="mySwiper"
          >
              <SwiperSlide>
             
    <div>
        <img src="assets\images\newdesign\event01.png" alt="" />
        <br />
        <br />
        <h3>Raipur Marathon</h3>
        <p className='d-flex gap-2 align-items-center mb-0'><SlLocationPin />Dubai, 2024</p>
    </div>
      </SwiperSlide>
              <SwiperSlide>
             
              <div>
        <img src="assets\images\newdesign\event02.png" alt="" />
        <br />
        <br />
        <h3>Raipur Marathon</h3>
        <p className='d-flex gap-2 align-items-center mb-0'><SlLocationPin />Dubai, 2024</p>
    </div>
      </SwiperSlide>
              <SwiperSlide>
             
              <div>
        <img src="assets\images\newdesign\event03.png" alt="" />
        <br />
        <br />
        <h3>Raipur Marathon</h3>
        <p className='d-flex gap-2 align-items-center mb-0'><SlLocationPin />Dubai, 2024</p>
    </div>
      </SwiperSlide>
              <SwiperSlide>
             
              <div>
        <img src="assets\images\newdesign\event01.png" alt="" />
        <br />
        <br />
        <h3>Raipur Marathon</h3>
        <p className='d-flex gap-2 align-items-center mb-0' ><SlLocationPin />Dubai, 2024</p>
    </div>
      </SwiperSlide>
          </Swiper>
        </div>
     </div>
    </Container> */}

        {/* SECTION 6 */}
        <div className="new-home-section3 new-home-section-6 py-5">
          <img
            src="assets\images\newdesign\newlogo2.png"
            className="new-home-section-6-back"
            alt=""
          />
          <img
            src="assets\images\newdesign\newlogo2.png"
            className="new-home-section-6-back2"
            alt=""
          />
          <Container className="py-5">
            <div>
              <h2 className="custom-new-header">
                What Our <br />
                <span className="custom-new-text">Stepmint User</span> say
              </h2>
            </div>
            <div className="w-100 ">
              {/* Custom Arrows */}

              {/* Swiper */}
              <Swiper
                modules={[Navigation, Pagination]}
                breakpoints={{
                  320: { slidesPerView: 1 }, // Small screens
                  768: { slidesPerView: 1 }, // Tablets
                  1024: { slidesPerView: 2 }, // Desktops
                  1440: { slidesPerView: 3 }, // Larger screens
                }}
                spaceBetween={30}
                onSwiper={(swiper) => (swiperRef.current = swiper)}
                navigation={{
                  nextEl: ".custom-swiper-button-next",
                  prevEl: ".custom-swiper-button-prev",
                }}
                pagination={{ clickable: true }}
                className="mySwiper"
              >
              
                <SwiperSlide>
                  <div
                    className="new-home-testimonial m-2
    px-4 py-3"
                  >
                    <div className="d-flex align-items-center gap-2 mb-3 pt-3">
                      {/* <img
                        src="assets\images\newdesign\user01.png"
                        alt=""
                        style={{ borderRadius: 10 }}
                      /> */}
                      <div className=" random-color-test">
                        <h3 className="mb-0">P</h3>
                      </div>
                      <h4 className="mb-0">Paras</h4>
                    </div>
                    <p className="">
                    Amazing Experience! Mr. Mint app has exceeded my expectations! User-friendly interface, seamless navigation, and fantastic features.The team's dedication to providing an outstanding experience.
                    </p>
                    <div className="d-flex mb-2 w-100 justify-content-between align-items-center">
                      <div>
                        <img src="assets\images\newdesign\star.svg" alt="" />
                        <img src="assets\images\newdesign\star.svg" alt="" />
                        <img src="assets\images\newdesign\star.svg" alt="" />
                        <img src="assets\images\newdesign\star.svg" alt="" />
                        <img src="assets\images\newdesign\star.svg" alt="" />
                      </div>
                      <small>15 November 2024</small>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div
                    className="new-home-testimonial m-2
    px-4 py-3"
                  >
                    <div className="d-flex align-items-center gap-2 mb-3 pt-3">
                      {/* <img
                        src="assets\images\newdesign\user01.png"
                        alt=""
                        style={{ borderRadius: 10 }}
                      /> */}
                      <div className=" random-color-test2">
                        <h3 className="mb-0">RP</h3>
                      </div>
                      <h4 className="mb-0">Ramakrishna Pullindla</h4>
                    </div>
                    <p>
                    "Stepmint is a revolutionary move-to-earn app that combines fitness, fun, and rewards in one platform! It motivates you to stay active and healthy while earning crypto rewards. The sleek...
                    </p>
                    <div className="d-flex mb-2 w-100 justify-content-between align-items-center">
                      <div>
                        <img src="assets\images\newdesign\star.svg" alt="" />
                        <img src="assets\images\newdesign\star.svg" alt="" />
                        <img src="assets\images\newdesign\star.svg" alt="" />
                        <img src="assets\images\newdesign\star.svg" alt="" />
                        <img src="assets\images\newdesign\star.svg" alt="" />
                      </div>
                      <small>05 January 2025</small>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div
                    className="new-home-testimonial m-2
    px-4 py-3"
                  >
                    <div className="d-flex align-items-center gap-2 mb-3 pt-3">
                      {/* <img
                        src="assets\images\newdesign\user01.png"
                        alt=""
                        style={{ borderRadius: 10 }}
                      /> */}
                      <div className=" random-color-test3">
                        <h3 className="mb-0">R</h3>
                      </div>
                      <h4 className="mb-0">Rocko</h4>
                    </div>
                    <p>
                    This app is good for both health and wealth... Please dont
                      believe in fake and negative reviews because time and
                      money both are important for current scenario .. ..its
                      highly recommended....
                    </p>
                    <div className="d-flex mb-2 w-100 justify-content-between align-items-center">
                      <div>
                        <img src="assets\images\newdesign\star.svg" alt="" />
                        <img src="assets\images\newdesign\star.svg" alt="" />
                        <img src="assets\images\newdesign\star.svg" alt="" />
                        <img src="assets\images\newdesign\star.svg" alt="" />
                        <img src="assets\images\newdesign\star.svg" alt="" />
                      </div>
                      <small>25 January 2025</small>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div
                    className="new-home-testimonial m-2
    px-4 py-3"
                  >
                    <div className="d-flex align-items-center gap-2 mb-3 pt-3">
                      {/* <img
                        src="assets\images\newdesign\user01.png"
                        alt=""
                        style={{ borderRadius: 10 }}
                      /> */}
                      <div className=" random-color-test3">
                        <h3 className="mb-0">AG</h3>
                      </div>
                      <h4 className="mb-0">Anil Gurjer</h4>
                    </div>
                    <p>
                    I love this app since my journey of financial freedom started. One of the best crypto nft platform where I can gain wealth with health. Join the community.
                    </p>
                    <div className="d-flex mb-2 w-100 justify-content-between align-items-center">
                      <div>
                        <img src="assets\images\newdesign\star.svg" alt="" />
                        <img src="assets\images\newdesign\star.svg" alt="" />
                        <img src="assets\images\newdesign\star.svg" alt="" />
                        <img src="assets\images\newdesign\star.svg" alt="" />
                        <img src="assets\images\newdesign\star.svg" alt="" />
                      </div>
                      <small>02 March 2025</small>
                    </div>
                  </div>
                </SwiperSlide>
              
              </Swiper>
              <div className="d-flex gap-2 mt-3 justify-content-end align-items-center">
          <button ref={prevRef} className="custom-swiper-button-prev">
            <FaChevronLeft style={{ color: "white" }} />
          </button>

          <button ref={nextRef} className="custom-swiper-button-next">
            <FaChevronRight style={{ color: "white" }} />
          </button>
        </div>
            </div>
          </Container>
        </div>

        {/* SECTION 7 */}

        <DownloadSection />
        {/* SECTION 8 */}
      </div>
      <Footer />
    </>
  );
};

export default NewHome;
